import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { PaginationConfig } from './pagination.config';

import { PagerComponent } from './pager.component';
import { PaginationComponent } from './pagination.component';


export class PaginationModule {
  public static forRoot(): ModuleWithProviders {
    return {ngModule: PaginationModule, providers: [PaginationConfig]};
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [CommonModule],
  declarations: [PagerComponent, PaginationComponent],
  exports: [PagerComponent, PaginationComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
